module.exports = __webpack_public_path__ + "static/img/logo-card-orange.3c43f28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/logo-card-orange.svg
// module id = 852
// module chunks = 2 3 4 5